export default __webpack_public_path__ + "static/zhijian-8414fbc9a9e8faa995809f5d7c8c83ca.jpg";